import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'

type TTypeNotification = 'success' | 'error'

export interface INotificationState {
  isActive: boolean
  message: string
  type: TTypeNotification
  isLoading: boolean
}

const initialState: INotificationState = {
  isActive: false,
  message: '',
  type: 'success',
  isLoading: false
}

export const notificationSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setNotificationError: (state, action: PayloadAction<string>) => {
      state.isActive = true
      state.message = action.payload
      state.type = 'error'
      state.isLoading = true
    },
    setNotificationMessage: (
      state,
      action: PayloadAction<
        Partial<Pick<INotificationState, 'message' | 'isLoading' | 'type'>>
      >
    ) => {
      state.message = action.payload.message ?? ''
      state.type = action.payload.type ?? 'success'
      state.isLoading = action.payload.isLoading ?? false
    },
    setNotificationIsActive: (state, action: PayloadAction<boolean>) => {
      state.isActive = action.payload
    }
  }
})

export const notificationReducer = notificationSlice.reducer
export const useNotificationActions = () =>
  useDispatchedActions(notificationSlice.actions)
